<template>
  <div v-if="$hasFonction(user, 'Activer navires')">
    <div :hidden="hiddenLoader" id="loader" class="text-center">
      <b-icon-circle-fill animation="throb" font-scale="4"></b-icon-circle-fill>
    </div>

    <div>
      <div v-show="add">
        <app-collapse>
          <app-collapse-item
            isVisible
            title="Ajouter un navire"
            v-if="$hasFonction(user, 'Ajouter navires')"
          >
            <!-- form start -->
            <validation-observer ref="addForm">
              <b-form class="mt-2" @submit.prevent>
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="name"
                    rules="required"
                  >
                    <label for="name">Navire</label>
                    <b-form-input
                      id="name"
                      v-model="defaultForm.name"
                      :state="errors.length > 0 ? false : null"
                      type="text"
                      placeholder="Navire"
                      @click="resetInputName"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small class="text-danger">{{ errorsName }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- submit button start -->
                <div class="mt-3">
                  <b-button
                    class="mr-2"
                    variant="outline-secondary"
                    type="reset"
                    @click="resetInputName"
                  >
                    Annuler
                  </b-button>

                  <b-button
                    v-if="etatButton"
                    variant="primary"
                    type="submit"
                    :disabled="isOperating"
                    @click.prevent="addNavire"
                  >
                    Enregistrer
                  </b-button>

                  <b-button v-else variant="primary">
                    <b-icon-arrow-clockwise
                      animation="spin"
                      font-scale="1"
                    ></b-icon-arrow-clockwise>
                    En cours
                  </b-button>
                </div>
                <!-- submit button end -->
              </b-form>
            </validation-observer>
            <!-- form end -->
          </app-collapse-item>
        </app-collapse>
      </div>

      <div :hidden="hidden">
        <app-collapse>
          <app-collapse-item
            ref="collapse"
            title="Ajouter un navire"
            v-if="$hasFonction(user, 'Ajouter navires')"
          >
            <!-- form start -->
            <validation-observer ref="addForm">
              <b-form class="mt-2" @submit.prevent>
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="name"
                    rules="required"
                  >
                    <label for="name">Navire</label>
                    <b-form-input
                      id="name"
                      v-model="defaultForm.name"
                      :state="errors.length > 0 ? false : null"
                      type="text"
                      placeholder="Navire"
                      @click="resetInputName"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small class="text-danger">{{ errorsName }}</small>
                  </validation-provider>
                </b-form-group>
                <!-- submit button start -->
                <div class="mt-3">
                  <b-button
                    class="mr-2"
                    variant="outline-secondary"
                    type="reset"
                    @click="resetInputName"
                  >
                    Annuler
                  </b-button>

                  <b-button
                    v-if="etatButton"
                    variant="primary"
                    type="submit"
                    :disabled="isOperating"
                    @click.prevent="addNavire"
                  >
                    Enregistrer
                  </b-button>

                  <b-button v-else variant="primary">
                    <b-icon-arrow-clockwise
                      animation="spin"
                      font-scale="1"
                    ></b-icon-arrow-clockwise>
                    En cours
                  </b-button>
                </div>
                <!-- submit button end -->
              </b-form>
            </validation-observer>
            <!-- form end -->
          </app-collapse-item>
        </app-collapse>

        <b-card no-body title="" class="mt-1">
          <div class="container-search-btn flex-stack my-2 mx-2">
            <!-- search start -->
            <div class="container-search mr-1">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Recherche"
              >
              </b-form-input>
            </div>
            <!-- search end -->

            <!-- bouton export start -->
			<div>
				<b-button
				v-if="$hasFonction(user, 'Exporter navires')"
				variant="outline-primary"
				size="sm"
				@click="ExportFomatExcel"
				>
				<b-icon-file-earmark-arrow-down-fill></b-icon-file-earmark-arrow-down-fill>
				Exporter
				</b-button>

        <b-button
				v-if="$hasFonction(user, 'Exporter navires')"
				variant="outline-primary"
				size="sm"
        class="ml-sm-2 mt-2 mt-sm-0"
				@click="ExportAllToFomatExcel"
				>
				<b-icon-file-earmark-arrow-down-fill></b-icon-file-earmark-arrow-down-fill>
				Tout Exporter
				</b-button>

			</div>
            <!-- bouton export end -->
          </div>

          <!-- table start -->
          <b-table
            v-model="ExcelNavires"
            id="my-table"
            responsive="sm"
            :fields="headers"
            :items="navires"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            @filtered="onFiltered"
            show-empty
            class="border-bottom"
          >
            <!-- iconAction start -->
            <template #cell(actions)="data">
              <div class="row">
                <div>
                  <b-button
                    :id="'button-1' + data.item.id"
                    v-if="$hasFonction(user, 'Modifier navires')"
                    size="sm"
                    variant="flat-primary"
                    class="btn-icon"
                    @click="editNavire(data.item)"
                  >
                    <feather-icon icon="Edit2Icon" />
                  </b-button>
                  <!-- <b-tooltip
                    :target="'button-1' + data.item.id"
                    title="Editer"
                    variant="dark"
                  ></b-tooltip> -->
                </div>
                <div>
                  <b-button
                    :id="'button-2' + data.item.id"
                    v-if="$hasFonction(user, 'Supprimer navires')"
                    size="sm"
                    variant="flat-danger"
                    @click="deleteNavire(data.item)"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                  <!-- <b-tooltip
                    :target="'button-2' + data.item.id"
                    title="Supprimer"
                    variant="dark"
                  ></b-tooltip> -->
                </div>
              </div>
            </template>
            <!-- iconAction end -->

            <template #empty>
              <div class="text-center">
                <span class="text-nowrap">Aucune donnée existante</span>
              </div>
            </template>
            <template #emptyfiltered>
              <div class="text-center">
                <span class="text-nowrap"
                  >L'élément recherché n'est pas dans la liste</span
                >
              </div>
            </template>
          </b-table>
          <!-- table end -->

          <div class="my-2 mx-2 row">
            <!-- per-page end -->
            <div class="col">
              <b-form-select
                id="per-page-select"
                v-model="perPage"
                :options="pageOptions"
                style="width: 70px"
              ></b-form-select>
              <span class="text-nowrap ml-1" v-if="allRows != 0"> 1 - <span v-if="perPage >= allRows">{{ allRows }}</span> 
	                <span v-if="perPage < allRows"> {{perPage}} </span> sur {{ allRows }}
                  </span>
              <span class="text-nowrap ml-1" v-if="allRows == 0"> 0 éléments</span>
            </div>
            <!-- per-page end -->

            <!-- pagination start -->
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              aria-controls="my-table"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
            <!-- pagination end -->
          </div>
        </b-card>

        <!-- modal edit start  -->
        <b-modal
          id="modal-edit"
          v-model="modalEdit"
          :ok-disabled="isOperating"
          title="Modifier les informations"
          @hidden="resetModal"
          hide-footer
          centered
        >
          <!-- form start -->
          <b-form ref="editForm" @submit.stop.prevent="handleSubmit">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="name"
                rules="required"
              >
                <label for="name">Navire</label>
                <b-form-input
                  id="name"
                  placeholder="Navire"
                  type="text"
                  v-model="editedForm.name"
                  :state="errors.length > 0 ? false : null"
                  @click="resetInputNameModal"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <small class="text-danger">{{
                  errors[0] ? "" : errorsNameModal
                }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group class="mb-0">
              <b-button
                variant="outline-secondary"
                type="reset"
                class="mt-2 mr-1"
                @click="modalEdit = false"
              >
                Annuler
              </b-button>

              <b-button
                v-if="etatButtonEdit"
                variant="primary"
                class="mt-2"
                :disabled="isOperating"
                @click="handleOk"
              >
                Enregistrer
              </b-button>

              <b-button v-else variant="primary" class="mt-2">
                <b-icon-arrow-clockwise
                  animation="spin"
                  font-scale="1"
                ></b-icon-arrow-clockwise>
                En cours
              </b-button>
            </b-form-group>
          </b-form>
          <!-- form end -->
        </b-modal>
        <!-- modal edit end-->
      </div>

      <div :hidden="hiddenEmpty" class="text-center">
        <empty-list></empty-list>
        <b-button variant="primary" size="sm" @click="etatAdd">
          <b-icon-plus></b-icon-plus>
          AJOUTER
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EmptyList from "@core/components/empty-list/EmptyList.vue";
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import { json2excel, excel2json } from "js2excel";
import downloadExcel from "json2excel-js";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, integer, alpha, alphaDash } from "@validations";
import exportFromJSON from 'export-from-json';
import {
  BCard,
  BTable,
  BCardText,
  BAlert,
  BModal,
  BPagination,
  BButton,
  BIconPencilFill,
  BIconTrashFill,
  BIconPlus,
  BIconArrowClockwise,
  BIconCircleFill,
  BIconFileEarmarkArrowDownFill,
  BForm,
  BRow,
  BCol,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BFormInput,
  BCollapse,
  BFormInvalidFeedback,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BTable,
    BModal,
    BCardText,
    BAlert,
    BCardCode,
    BPagination,
    BButton,
    EmptyList,
    BIconPlus,
    BIconPencilFill,
    BIconTrashFill,
    BIconArrowClockwise,
    BIconCircleFill,
    BIconFileEarmarkArrowDownFill,
    BForm,
    BRow,
    BCol,
    BTooltip,
    BFormGroup,
    BFormSelect,
    BFormInput,
    BCollapse,
    BFormInvalidFeedback,
    AppCollapse,
    AppCollapseItem,
    ValidationProvider,
    ValidationObserver,
    json2excel,
    excel2json,
    downloadExcel,
  },

  data() {
    return {
      etatButton: true,
      etatButtonEdit: true,
      add: false,
      hidden: true,
      hiddenEmpty: true,
      hiddenLoader: false,
      isOperating: false,
      required,
      integer,
      alpha,
      alphaDash,
      nameState: null,
      errorsName: null,
      errorsNameModal: null,
      modalEdit: false,
      // totalRows: 1,
      perPage: 5,
      currentPage: 1,
      allRows: 0,
      filter: null,
      pageOptions: [],
      headers: [
        {
          key: "name",
          label: "Nom",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "w-25",
        },
      ],
      navires: [],
      ExcelNavires: [],
      editedForm: {
        name: "",
      },
      defaultForm: {
        name: "",
      },
    };
  },

  mounted() {},

  computed: {
    ...mapState({
      user: (state) => state.user.auth,
    }),
    totalRows() {
      // Set the initial number of items
      this.pageOptions = [5, 10, 25, 50, 100, { value: this.navires.length, text: "Tout" } ]
      return this.allRows;
    },
  },

  created() {
    this.getNavires();
  },

  methods: {
    etatAdd() {
      this.add = true;
      this.hiddenEmpty = true;
    },
    resetForm() {
      this.defaultForm.name = "";
    },
    resetModal() {
      this.editedForm.name = "";
      this.nameState = null;
      this.resetInputNameModal();
    },
    resetInputNameModal() {
      if (this.errorsNameModal) {
        this.errorsNameModal = null;
      }
    },
    resetInputName() {
      if (this.errorsName) {
        this.errorsName = null;
      }
    },

    onFiltered(filteredItems) {
        this.allRows =  filteredItems.length 
        this.currentPage = 1
      },

    showToast(titre, type) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: titre,
          icon: type === "success" ? "CheckSquareIcon" : "AlertCircleIcon",
          variant: type,
        },
      });
    },
    getNavires() {
      this.$http
        .get("/navires")
        .then((res) => {
          if (res.status) {
            this.hiddenLoader = true;
          }

          this.navires = res.data.data.reverse();

          if (this.navires.length) {
            this.hidden = false;
            this.hiddenEmpty = true;
          } else {
            this.hidden = true;
            this.hiddenEmpty = false;
          }

          this.allRows = this.navires.length

        })
        .catch((e) => {
          e.response.data.message;
        });
    },
    addNavire() {
      this.$refs.addForm.validate().then((success) => {
        if (success) {
          this.etatButton = false;
          this.$http
            .post("/navires", this.defaultForm)
            .then((result) => {
              // 	this.isOperating = false;
              if (result.data.success) {
                this.etatButton = true;
                this.resetInputName();
                this.defaultForm = JSON.parse(
                  JSON.stringify({ type: Object, default: () => {} })
                );
                this.add = false;
                this.$refs.addForm.reset();
                this.showToast("Navire ajouté avec succès", "success");
                if (this.navires.length) {
                  this.$refs.collapse.updateVisible(false);
                }
                this.getNavires();
                // this.resetForm()
              } else {
                this.etatButton = true;
                this.showToast(result.data.message, "danger");
              }
            })
            .catch((e) => {
              this.etatButton = true;
              var err = e.response.data.errors;
              // this.isOperating = false;

              if (err) {
                if (err.name) {
                  this.errorsName = err.name[0];
                }
              }
            });
        }
      });
    },
    checkFormValidity() {
      const valid = this.$refs.editForm.checkValidity();
      this.nameState = valid;
      return valid;
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }
      this.etatButtonEdit = false;
      this.$http
        .put("/navires/" + this.editedForm.id, this.editedForm)
        .then((result) => {
          if (result.data.success) {
            this.etatButtonEdit = true;
            this.resetInputNameModal();
            this.editedForm = JSON.parse(
              JSON.stringify({ type: Object, default: () => {} })
            );
            this.modalEdit = false;
            this.showToast("Navire modifié avec succès", "success");
            this.getNavires();
            this.$refs.addForm.reset();
          } else {
            this.etatButtonEdit = true;
            this.showToast(result.data.message, "danger");
          }
        })
        .catch((e) => {
          this.etatButtonEdit = true;
          console.log("erreur modification:" + e);
          // this.isOperating = false;
          var err = e.response.data.errors;
          // this.isOperating = false;

          if (err.name) {
            this.errorsNameModal = err.name[0];
          }
        });
      // 	}
      // });

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();

      // Trigger submit handler
      this.handleSubmit();
    },
    editNavire(item) {
      this.editedForm = Object.assign({}, item);
      this.modalEdit = true;
    },
    deleteNavire(item) {
      // Message de suppression
      this.$bvModal
        .msgBoxConfirm(
          "Voulez-vous vraiment supprimer cet enregistrement de la liste des navires ?",
          {
            title: "Supprimer un navire",
            okVariant: "danger",
            cancelVariant: "outline-secondary",
            okTitle: "Confirmer",
            cancelTitle: "Annuler",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value === true) {
            this.$http
              .delete("/navires/" + item.id)
              .then((result) => {
                if (result.data.success) {
                  this.showToast("Supression effectuée avec succès", "success");
                  this.getNavires();
                } else {
                  this.showToast(result.data.message, "danger");
                }
              })
              .catch((err) => {
                this.showToast(err.response, "error");
              });
          }
        });
    },
    ExportFomatExcel() {
      let { json2excel, excel2json } = require("js2excel");
      // let headers = this.headers
      let data = [];
      let obj = {};

      this.ExcelNavires.forEach((element) => {
        obj = {
          "DATE D'AJOUT": element.created_at,
          NOM: element.name,
        };

        data.push(obj);
      });

      if (data) {
        try {
          const exportType =  exportFromJSON.types.csv;
          const fileName = 'FlashCar - Liste des Navires';

          exportFromJSON({ data, fileName, exportType })

          /*  json2excel({
              // headers,
              data,
              name: "FlashCar - Liste des Navires",
              formateDate: "yyyy/mm/dd",
            });*/
        } catch (e) {
          console.log(e);
        }
      }
    },


    ExportAllToFomatExcel() {
      let { json2excel, excel2json } = require("js2excel");
      // let headers = this.headers
      let data = [];
      let obj = {};

      this.navires.forEach((element) => {
        obj = {
          "DATE D'AJOUT": element.created_at,
          NOM: element.name,
        };

        data.push(obj);
      });

      if (data) {
        try {
          json2excel({
            // headers,
            data,
            name: "FlashCar - Liste des Navires",
            formateDate: "yyyy/mm/dd",
          });
        } catch (e) {
          console.log(e);
        }
      }
    },

  },
};
</script>

<style>
	#loader {
		position: absolute;
		width: 100%;
		height: 100%;
		background-color: #f8f8f8;
		padding-top: 15%;
		z-index: 1000;
	}

	.container-search-btn {
		display: flex !important;
	}

	.flex-stack {
		justify-content: space-between;
		align-items: center;
	}
	
	@media screen and (max-width: 435px) {
		.container-search-btn {
			display: flex !important;
		}

		.container-search {
			width: 50%;
		}
	}

	@media screen and (max-width: 327px) {
		.container-search {
			width: 100%;
			margin-bottom: 10px;
		}

		.container-search-btn {
			display: block !important;
		}
	}

	@media screen and (max-width: 720px) {
		.blockSearch {
			width: 80% !important;
		}

		.search {
			width: 250px !important;
			margin-bottom: 10px;
		}
	}

	@media screen and (max-width: 620px) {
		.blockSearch {
			width: 75% !important;
		}

		.search {
			width: 250px !important;
			margin-bottom: 10px;
		}
	}
</style>
